
document.addEventListener("DOMContentLoaded", function () {

  // 1. Leggiamo i dati dall'oggetto globale che abbiamo creato in Liquid
  const data = window.ShopifyData || {};
const customerId = data.customerId;
const customerEmail = data.customerEmail;
const shopUrl = data.shop;

  // Se l'utente non è loggato (customerId è null), fermiamo tutto
  if (!customerId) {
    console.log("Utente non loggato: monitoraggio disattivato.");
    return;
  }

  const WEBHOOK_URL = 'https://hook.us2.make.com/e1qok82obi6suj9wjvnc7eoudea09n9h';

  function sendCartDataToWebhook() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const payload = {
          timestamp: new Date().toISOString(),
          shop: shopUrl,
          event: 'checkout_clicked',
          customer: {
            id: customerId,      // Usiamo la variabile letta sopra
            email: customerEmail // Usiamo la variabile letta sopra
          },
          cart: cart
        };
        fetch(WEBHOOK_URL, {
          method: 'POST',
          body: JSON.stringify(payload),
          headers: { 'Content-Type': 'application/json' },
          keepalive: true,
          credentials: 'omit'
        });
      })
      .catch(err => {
    window.logCustomerError && window.logCustomerError(err, { feature: 'checkout_click_tracking' });
  });
  }

  // Event Listener sui bottoni checkout
  const buttons = document.querySelectorAll('[name="checkout"], .Cart__Checkout, form[action="/cart"] [type="submit"]');
  buttons.forEach(btn => {
    btn.addEventListener('click', () => sendCartDataToWebhook());
  });
});